import { useTranslation } from 'react-i18next'
import { useContext, useEffect, useState } from 'react'

import { AuthContext, UserContext } from '../../contexts'
import { numberWithCommas } from '../../utils'
import { countriesCurrencies, flagCodes } from '../../lib'
import { requestAccessToken } from '../../api/auth.api'
import { getBankBalancesBriefData } from '../../api/app-queries.api'
import { useSocket } from '../../hooks/use-socket'
import { CountryItem } from '../dashboard/country-item'

export const BalanceCard = () => {
  const selectedCountry = globalThis.sessionStorage.getItem('selectedCountry') || 'COL'
  const selectedCurrency = (countriesCurrencies as { [key: string]: string })[selectedCountry]

  const { isAuth } = useContext(AuthContext)
  const { userSession } = useContext(UserContext)
  const { appDataSocket, isAppDataSocketInitialized } = useSocket()
  const { t } = useTranslation(['insights-funding-history-management'])

  const [balanceValueToDisplay, setBalanceValueToDisplay] = useState<number>(0)

  useEffect(() => {
    if (!appDataSocket) return

    appDataSocket.on('updateSystemUser', async (dataFromSocket: any) => {
      if (String(userSession?._id) === String(dataFromSocket.systemUserId)) {
        handleGetBankBalancesBriefDataFromRemote()
      }
    })

    appDataSocket.on('addCustomerCompanyPocket', async (dataFromSocket: any) => {
      if (selectedCurrency === dataFromSocket.currency) {
        handleGetBankBalancesBriefDataFromRemote()
      }
    })

    appDataSocket.on('updateCustomerCompanyPocket', async (dataFromSocket: any) => {
      if (selectedCurrency === dataFromSocket.currency) {
        handleGetBankBalancesBriefDataFromRemote()
      }
    })

    appDataSocket.on('deleteCustomerCompanyPocket', async (dataFromSocket: any) => {
      if (selectedCurrency === dataFromSocket.currency) {
        handleGetBankBalancesBriefDataFromRemote()
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appDataSocket, isAppDataSocketInitialized])

  useEffect(() => {
    if (userSession) {
      handleGetBankBalancesBriefData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSession])

  const handleGetBankBalancesBriefData = async () => {
    let localBankBalancesBriefDataToSet: any = {}
    const selectedCountry = globalThis.sessionStorage.getItem('selectedCountry') || 'COL'
    const localBankBalancesBriefData = globalThis.sessionStorage.getItem(`bankBalancesBriefData:${selectedCountry}`)

    if (localBankBalancesBriefData) {
      localBankBalancesBriefDataToSet = JSON.parse(localBankBalancesBriefData)
      handleSetInitialBankBalancesBriefData(localBankBalancesBriefDataToSet)
    }

    handleGetBankBalancesBriefDataFromRemote()
  }

  const handleGetBankBalancesBriefDataFromRemote = async () => {
    try {
      const {
        data: { accessToken }
      } = await requestAccessToken(isAuth?.replaceAll('"', '') ?? '')
      const { data } = await getBankBalancesBriefData(String(userSession?._id), selectedCountry, accessToken)

      globalThis.sessionStorage.setItem(`bankBalancesBriefData:${selectedCountry}`, JSON.stringify(data))
      handleSetInitialBankBalancesBriefData(data)
    } catch (error: any) {
      console.log('Error handleGetBankBalancesBriefDataFromRemote > ', error)
    }
  }

  const handleSetInitialBankBalancesBriefData = (dataToSet: any) => {
    setBalanceValueToDisplay(dataToSet.balanceBriefData.totalBalance)
  }

  return (
    <div className="items-center bg-white flex min-h-[88px] w-full gap-4 md:gap-8 text-sm md:text-base font-bold flex-wrap p-4 md:p-6 rounded-xl">
      <div className="text-[#737373] self-stretch my-auto w-[140px] h-[24px] font-['Open_Sans'] font-[700] text-[16px] leading-[24px] tracking-[0%]">{t('insights.currentBalance')}</div>
      <div className="self-stretch flex flex-wrap items-center gap-4 md:gap-6 text-neutral-500 my-auto">
        <div className="self-stretch flex items-center gap-2 md:gap-4 my-auto">
          <div className="self-stretch flex items-center gap-2 my-auto">
            <CountryItem
              hideName
              name={selectedCountry}
              code={(flagCodes as { [key: string]: string | TrustedHTML })[selectedCountry]}
            />
            <div className="self-stretch text-[#737373] font-['Open_Sans'] font-[700] text-[16px] h-[24px] leading-[24px] tracking-[0%]">{`$ ${numberWithCommas(
              balanceValueToDisplay
            )} ${selectedCurrency.toUpperCase()}`}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
